import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { RsbService } from 'src/app/service/rsb.service';

@Component({
  selector: 'app-support',
  templateUrl: './support.component.html',
  styleUrls: ['./support.component.css']
})
export class SupportComponent implements OnInit {
  comment: string = ''; 
  getSupportData: any[] = [
    {
      supportId: 'TKT-2001',
      updatedAt: '2026-09-01',
      comment: 'Unable to update project pricing.',
      tktUpdates: 'Our support team is reviewing the request.'
    },
    {
      supportId: 'TKT-2002',
      updatedAt: '2026-09-06',
      comment: 'Please help me add a new team member.',
      tktUpdates: 'Response shared with the builder.'
    },
    {
      supportId: 'TKT-2003',
      updatedAt: '2026-09-07',
      comment: 'Project images are not uploading.',
      tktUpdates: 'Upload settings have been refreshed.'
    },
    {
      supportId: 'TKT-2004',
      updatedAt: '2026-09-08',
      comment: 'Need help exporting lead data.',
      tktUpdates: 'Export guide shared.'
    },
    {
      supportId: 'TKT-2005',
      updatedAt: '2026-09-09',
      comment: 'Property details need to be updated.',
      tktUpdates: 'Request assigned to the support team.'
    },
    {
      supportId: 'TKT-2006',
      updatedAt: '2026-09-10',
      comment: 'Unable to view the project dashboard.',
      tktUpdates: 'Access permissions were checked.'
    },
    {
      supportId: 'TKT-2007',
      updatedAt: '2026-09-11',
      comment: 'How can I add another project?',
      tktUpdates: 'Project creation steps shared.'
    },
    {
      supportId: 'TKT-2008',
      updatedAt: '2026-09-11',
      comment: 'Lead contact information is incorrect.',
      tktUpdates: 'The record is being reviewed.'
    },
    {
      supportId: 'TKT-2009',
      updatedAt: '2026-09-11',
      comment: 'Please explain the loan status.',
      tktUpdates: 'Loan status details shared.'
    },
    {
      supportId: 'TKT-2010',
      updatedAt: '2026-09-11',
      comment: 'Team member invite is pending.',
      tktUpdates: 'Invite has been sent again.'
    }
  ];
  statusForSubmitted:boolean=false;
  isMobileLayout:boolean=false;

  statusForInProgress:boolean=false;
  statusForCancel:boolean=false;
  constructor(private rsbService: RsbService,private toastr: ToastrService) { }

  ngOnInit(): void {
    this.isMobileLayout = window.innerWidth <= 1024;
    window.onresize = () => this.isMobileLayout = window.innerWidth <= 1024;
    this.statusForSubmitted = true;
  }

  onCommentChange(event: Event): void {
    const inputElement = event.target as HTMLTextAreaElement;
    this.comment = inputElement.value; 
  }
  getSupport(): void {
    this.rsbService.getSupport().subscribe((res)=>{
      if(res.statusCode === 0 && res.contents.length) {
      this.getSupportData=res.contents;
      this.statusForSubmitted=true;

      } 
      else if(res.statusCode === 1){
        this.statusForInProgress=true;
      }
      else{
        this.statusForCancel=true;

      }
    })

  }
  

  submit() {
    console.log(this.comment); 
    if (this.comment) {
      this.rsbService.queryForSupport(this.comment).subscribe((rsp) => {
        if(rsp.statusCode===0){
          this.toastr.success('submitted successfully.');

          this.getSupport();
          this.statusForSubmitted=true;

        }

        });
    } 
  }
}